module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp3_8019.0d70c484.png";